import React from 'react';
import { Box, Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PatientProfileInfoAccordion } from '../PatientProfileInfoAccordion';
import { UpcomingSessionCard } from './UpcomingSessionCard.component';
import { Appointment } from '@uplift/api';


const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));


export type UpcomingSessionsAccordionProps = {
  sessions: Pick<Appointment, 'id' | 'fromDatetime' | 'recurring' | 'type'>[];
};


export const UpcomingSessionsAccordion: React.VFC<UpcomingSessionsAccordionProps> = (props) => {
  const { classes } = useStyles();

  return (
    <PatientProfileInfoAccordion
      title="Upcoming Sessions"
      chip={(
        <Chip size="small" label={props.sessions.length} />
      )}
    >
      {props.sessions.length ? (
        <Box className={classes.root}>
          {props.sessions.map(session =>
            <UpcomingSessionCard key={session.id} session={session} />
          )}
        </Box>
      ) : null}
    </PatientProfileInfoAccordion>
  );
};
